<template>
    <g>
        <!-- 파티클들 -->
        <circle
            v-for="(p, i) in particles"
            :key="i"
            :cx="p.x"
            :cy="p.y"
            :r="p.radius"
            :fill="p.color"
            :opacity="p.opacity"
            filter="url(#glow)"
        />

        <!-- Glow 효과 -->
        <defs>
            <filter id="glow" x="-50%" y="-50%" width="200%" height="200%" filterUnits="userSpaceOnUse">
                <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" result="blur" />
                <feMerge>
                    <feMergeNode in="blur" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>
    </g>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';

interface Props {
    center: { x: number; y: number };
}

const props = defineProps<Props>();

interface Particle {
    x: number;
    y: number;
    radius: number;
    opacity: number;
    color: string;
    dx: number;
    dy: number;
    do: number;
}

const particles = ref<Particle[]>([]);

const random = (min: number, max: number) => Math.random() * (max - min) + min;

const initParticles = () => {
    const colors = ['#E2F6FF', '#B4E8FF', '#53CBFF'];
    const initSpread = 4;

    particles.value = [];
    for (let i = 0; i < 20; i++) {
        particles.value.push({
            x: props.center.x + random(-initSpread, initSpread),
            y: props.center.y + random(-initSpread, initSpread),
            radius: random(0.3, 0.8),
            opacity: random(0.3, 1),
            color: colors[Math.floor(Math.random() * colors.length)],
            dx: random(-0.03, 0.03),
            dy: random(-0.03, 0.03),
            do: random(-0.003, 0.003),
        });
    }
};

const animate = () => {
    for (const p of particles.value) {
        p.x += p.dx;
        p.y += p.dy;
        p.opacity += p.do;

        const distX = p.x - props.center.x;
        const distY = p.y - props.center.y;

        if (Math.abs(distX) > 8) p.dx *= -1;
        if (Math.abs(distY) > 8) p.dy *= -1;
        if (p.opacity < 0.1 || p.opacity > 1) p.do *= -1;
    }

    requestAnimationFrame(animate);
};

onMounted(() => {
    initParticles();
    requestAnimationFrame(animate);
});

watch(
    () => props.center,
    () => {
        initParticles();
    },
);
</script>
